/* Timbrica animated fog footer.
   Procedural (non-symmetric) mountain ridges via midpoint-displacement +
   drifting "vapor" particles that fade in/out BETWEEN the back layers
   (never in front of the nearest ridge). Wordmark drawn on top of fog.
   Lazy: only animates while the footer is on screen. Respects reduced-motion.
   Theme follows <html data-theme>. Brand text comes from data-wordmark.

   ТРИ СЛОЯ, а не один холст (2026-08-31). Раньше каждый кадр перерисовывал
   ВСЁ — шесть силуэтов, шесть градиентов и огромную надпись, — и чтобы это
   влезало в бюджет, ВЕСЬ холст держали в ПОЛОВИННОМ разрешении. Половина
   разрешения незаметна только там, где картинка мягкая: у силуэта горы и у
   букв края жёсткие, и апскейл на них видно глазом. Разделение снимает
   размен целиком, а не смягчает его:
     1. горы   — <canvas>, полный DPR, перерисовка ТОЛЬКО на ресайз / смену
                 темы / «другие горы»;
     2. туман  — <canvas>, половинный DPR (ровно как было), единственный
                 слой в rAF: мягкие пятна апскейл переживают неразличимо;
     3. надпись — <svg><text>, вектор: чёткая при любом DPR и зуме, стоит
                 0 мс в кадре и сама переживает позднюю загрузку Inter
                 (холст рисовал её тем шрифтом, что был готов на тот кадр).
   Кадр от этого стал ДЕШЕВЛЕ, а не дороже: в нём остались только пятна —
   0.74× прежнего и без троттлинга, и при CPU 6× (замер 31.08, чередование
   конвейеров в одной странице по 120 пар; абсолютные миллисекунды на этой
   машине гуляют втрое, отношение — нет). Частота не изменилась: 25.1 → 25.5
   fps, доля главного потока 0.7% → 0.5%. Полная перерисовка гор в двойном
   разрешении стоит примерно как ОДИН прежний кадр (~5 мс) и случается раз на
   ресайз, а не 25 раз в секунду.
   На глаз это ширина перехода на сильном краю (dpr 1, содержимое футера
   скрыто, чтобы в кадр не попал DOM-текст): надпись 4.14 → 2.83 пикселя,
   хребты 4.86 → 2.80, и различимых краёв на горах стало вдвое с половиной
   больше (662 → 1675) — размытие их просто съедало. ⚠️ Средний градиент по
   кропу этого НЕ показывает (×1.01 там, где край сузился вдвое): он
   усредняет по плоским областям, которых в кадре большинство. */
(function(){
  var scene = document.querySelector('.footer--fog');
  if(!scene) return;
  var cv = scene.querySelector('.footer-fog-canvas');
  if(!cv || !cv.getContext) return;
  var ctx = cv.getContext('2d');            // слой 1: горы (статика, полный DPR)
  /* Холста может не дать сам браузер (getContext → null, когда у процесса кончилась
     память холстов — iOS 16, 29.10.2026): декорация тогда просто не рисуется. До этого
     null.fillStyle бросал на КАЖДОЙ странице такого устройства. */
  if(!ctx) return;
  /* Полразрешения у ТУМАНА намеренно: он — мягкие градиенты и дрейф, апскейл
     браузера на нём неразличим, а пикселей (и мс на кадр) вчетверо меньше.
     Замер 07.08 (софтверный растр, CPU 6×): полный кадр стоил 15.8 мс, и
     «оптимизация» блит-кэшем сделала ХУЖЕ (24.2 мс) — дешевле рисовать меньше
     пикселей, а не рисовать те же по-другому. Это по-прежнему верно ДЛЯ
     КАДРА; горы и надпись из кадра просто ушли. */
  var SS = 2;                                // во столько раз горы плотнее тумана
  var DPR = Math.min(2, window.devicePixelRatio || 1) * 0.5;
  var W=0, H=0;                              // логические координаты = пиксели тумана
  var WORD = (scene.getAttribute('data-wordmark') || 'Timbrica').trim();
  var speed = 1.2, seed = 1337, density;

  /* Слой 2 — туман. Отдельный холст, тот же бокс и тот же z-index: порядок
     решает позиция в DOM, поэтому горы под ним, а надпись над ним. */
  var fcv = document.createElement('canvas');
  fcv.className = 'footer-fog-canvas';
  fcv.setAttribute('aria-hidden','true');
  fcv.style.cssText = 'position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;display:block;pointer-events:none;z-index:1';
  cv.parentNode.insertBefore(fcv, cv.nextSibling);
  var fx = fcv.getContext('2d');
  if(!fx){ fcv.parentNode.removeChild(fcv); return; }
  fx.fillStyle='#000';                       // eraseRidge: важна только альфа источника

  /* Слой 3 — надпись. SVG, а не холст: вектор не зависит ни от DPR, ни от
     зума, и не стоит ни пикселя памяти под бэкстор. Геометрия ровно как у
     прежнего fillText: середина по X, базовая линия на 99.5% высоты (хвост
     «р» уходит за нижний край — svg подрезает его так же, как подрезал холст). */
  var SVGNS='http://www.w3.org/2000/svg', wsvg=null, wtxt=null;
  try{
    wsvg=document.createElementNS(SVGNS,'svg');
    wsvg.setAttribute('aria-hidden','true');
    wsvg.setAttribute('focusable','false');
    wsvg.style.cssText='position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;display:block;pointer-events:none;user-select:none;-webkit-user-select:none;z-index:1';
    wtxt=document.createElementNS(SVGNS,'text');
    wtxt.setAttribute('x','50%'); wtxt.setAttribute('y','99.5%');
    wtxt.setAttribute('text-anchor','middle');
    wtxt.style.cssText='font-weight:800;font-family:Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif';
    wtxt.textContent=WORD;
    wsvg.appendChild(wtxt);
    fcv.parentNode.insertBefore(wsvg, fcv.nextSibling);
  }catch(_e){ wsvg=null; wtxt=null; }

  function curTheme(){ return document.documentElement.getAttribute('data-theme')==='dark' ? 'dark' : 'light'; }
  function densFor(t){ return t === 'light' ? 3.6 : 1.8; } // light theme = 2x denser vapor than dark
  var theme = curTheme();
  density = densFor(theme);
  new MutationObserver(function(){
    theme = curTheme(); density = densFor(theme); ensurePuffs();
    // repaint immediately so the new palette shows even when the loop isn't running
    // (reduced-motion, or footer already painted off-screen) — fixes stale palette on theme switch
    paintStatic(); syncWordmark();
    if(!running) staticFrame();
  }).observe(document.documentElement, {attributes:true, attributeFilter:['data-theme']});

  var PAL = {
    light:{ m:['#c5d0e2','#b1c1db','#98abd0','#7e96c5','#6580b6','#4f6aa6'],
            haze:'235,242,251', word:'rgba(255,255,255,.55)' },
    dark:{  m:['#33415f','#2a3856','#212f4c','#192540','#121d33','#0d1628'],
            haze:'16,26,46', word:'rgba(255,255,255,.07)' }
  };

  function rngFrom(a){ return function(){ a|=0; a=a+0x6D2B79F5|0; var t=Math.imul(a^a>>>15,1|a); t=t+Math.imul(t^t>>>7,61|t)^t; return ((t^t>>>14)>>>0)/4294967296; }; }
  function mpd(power, rough, rnd){
    var n=(1<<power)+1, a=new Float32Array(n);
    a[0]=rnd(); a[n-1]=rnd(); var step=n-1, scale=1.0;
    while(step>1){ var half=step>>1;
      for(var i=half;i<n-1;i+=step){ a[i]=(a[i-half]+a[i+half])*0.5 + (rnd()*2-1)*scale; }
      step=half; scale*=rough; }
    var mn=Infinity,mx=-Infinity,k;
    for(k=0;k<n;k++){ if(a[k]<mn)mn=a[k]; if(a[k]>mx)mx=a[k]; }
    var d=(mx-mn)||1; for(k=0;k<n;k++) a[k]=(a[k]-mn)/d; return a;
  }
  var LAYERS=[
    {top:0.40, amp:0.11, power:6, rough:0.52},
    {top:0.48, amp:0.15, power:6, rough:0.55},
    {top:0.57, amp:0.18, power:7, rough:0.56},
    {top:0.67, amp:0.21, power:7, rough:0.58},
    {top:0.78, amp:0.25, power:7, rough:0.60},
    {top:0.88, amp:0.22, power:7, rough:0.62}
  ];
  var N=LAYERS.length, ridges=[];
  function buildMountains(){ var rnd=rngFrom(seed); ridges=LAYERS.map(function(L){ return mpd(L.power,L.rough,rnd); }); }
  function yAt(arr,x){ var n=arr.length,p=x*(n-1),i=p|0,f=p-i,a=arr[i],b=arr[Math.min(n-1,i+1)]; return a+(b-a)*f; }
  function ridgeY(li,xpx){ var L=LAYERS[li]; var x=xpx<0?0:(xpx>W?W:xpx); return H*L.top - L.amp*H*yAt(ridges[li], x/W); }

  /* Силуэт строится по САМИМ вершинам midpoint-displacement (65 или 129 точек),
     а не выборкой «через каждые W/300 px». Выборка мимо вершин срезала пики и
     добавляла собственное дрожание ПОВЕРХ апскейла: при W/300 сегмент был 3
     пикселя тумана = 6 экранных. Точек мало, слой рисуется раз на ресайз —
     платить за точность нечем. */
  function fillRidge(c, li){
    var L=LAYERS[li], P=PAL[theme], arr=ridges[li], n=arr.length, k;
    c.beginPath(); c.moveTo(0,H);
    for(k=0;k<n;k++){ c.lineTo(k/(n-1)*W, H*L.top - L.amp*H*arr[k]); }
    c.lineTo(W,H); c.closePath();
    c.fillStyle=P.m[li]; c.fill();
    var fade=1 - li/(N-0.2);
    if(fade>0){
      var gg=c.createLinearGradient(0,H*L.top-L.amp*H,0,H);
      gg.addColorStop(0,'rgba('+P.haze+',0)');
      gg.addColorStop(1,'rgba('+P.haze+','+(0.14*fade).toFixed(3)+')');
      c.fillStyle=gg; c.fill();
    }
  }
  function paintStatic(){
    if(!ridges.length || !W || !H) return;
    ctx.setTransform(SS,0,0,SS,0,0);          // рисуем в координатах тумана, пикселей вдвое больше
    ctx.clearRect(0,0,W,H);
    ctx.globalAlpha=1; ctx.globalCompositeOperation='source-over';
    for(var li=0; li<N; li++) fillRidge(ctx, li);
  }
  function syncWordmark(){
    if(!wtxt || !W || !H) return;
    // тот же размер, что рисовал холст: min(W*0.21, H*0.62) — но в CSS-пикселях
    wtxt.style.fontSize = (Math.min(W*0.21, H*0.62)/DPR).toFixed(2)+'px';
    wtxt.style.fill = PAL[theme].word;
  }

  // soft vapor sprite (no hot centre -> appears diffuse)
  var puff=document.createElement('canvas'), pctx=puff.getContext('2d'), PS=128;
  (function(){ puff.width=puff.height=PS;
    var g=pctx.createRadialGradient(PS/2,PS/2,0,PS/2,PS/2,PS/2);
    g.addColorStop(0,'rgba(255,255,255,.72)'); g.addColorStop(0.35,'rgba(255,255,255,.34)');
    g.addColorStop(0.7,'rgba(255,255,255,.1)'); g.addColorStop(1,'rgba(255,255,255,0)');
    pctx.fillStyle=g; pctx.beginPath(); pctx.arc(PS/2,PS/2,PS/2,0,7); pctx.fill();
  })();

  var pr=rngFrom(98765);
  function R(a,b){ return a+(b-a)*pr(); }
  var puffs=[];
  function spawn(p, first){
    // only BETWEEN back layers (band 1..N-2): no vapor in front of the nearest ridge
    p.band = 1 + Math.floor(Math.pow(pr(),0.6)*(N-2));
    if(p.band>N-2) p.band=N-2; if(p.band<1) p.band=1;
    p.x = R(-0.08,1.08)*W;
    var b=p.band, ry=ridgeY(b,p.x), depth=b/N;
    p.y = ry - H*0.03 + R(0, H*0.10);
    p.r = R(H*0.07, H*0.16)*(0.6+0.6*depth);     // size independent of density
    p.amax = R(0.05, 0.15)*(0.6+0.6*depth);       // faint -> appears transparent, no bright dot
    p.sx = R(2.4,3.9)*(0.85+0.25*density);        // density -> wider / more dispersed
    p.vx = R(-1,1)*0.16;
    p.vy = -R(0.004,0.045);
    p.max = R(380,1050);
    p.life = first ? R(0,p.max) : 0;
  }
  function ensurePuffs(){
    var target=Math.min(240, Math.round(90*density));  // cap particle count for perf
    while(puffs.length<target){ var p={}; spawn(p,true); puffs.push(p); }
    if(puffs.length>target) puffs.length=target;
  }
  var bandLive=[];
  function updatePuffs(){
    for(var b=0;b<N;b++) bandLive[b]=false;
    for(var i=0;i<puffs.length;i++){
      var p=puffs[i];
      p.life+=speed; if(p.life>=p.max){ spawn(p,false); }
      p.x+=p.vx*speed; p.y+=p.vy*speed;
      p.t=p.life/p.max; var a=Math.sin(Math.PI*p.t); a*=a;
      p.alpha=p.amax*a;
      if(p.alpha>0.003) bandLive[p.band]=true;
    }
  }
  function drawBand(li){
    for(var i=0;i<puffs.length;i++){ var p=puffs[i];
      if(p.band!==li || p.alpha<=0.003) continue;
      var gr=0.72+0.55*p.t;
      fx.globalAlpha=p.alpha; var w=p.r*p.sx*gr, h=p.r*gr;
      fx.drawImage(puff, p.x-w/2, p.y-h/2, w, h);
    }
  }

  /* Глубина без чередования холстов. Раньше порядок был
     ridge0, ridge1, band1, ridge2, band2, … — то есть пятно полосы li
     закрывали ВСЕ более близкие хребты, нарисованные ПОСЛЕ него. Горы уехали
     в слой ПОД туманом, и это надо восстановить: после каждой полосы стираем
     из тумана силуэт следующего хребта (destination-out). Стирание задним
     числом достаёт и предыдущие полосы, поэтому четырёх проходов хватает на
     все пары: полоса 1 в итоге обрезана хребтами 2–5, полоса 4 — только
     пятым. Композит выходит тот же, что рисовал прежний чередующийся цикл.
     Отсечение (clip по огибающей) формально эквивалентно и стоит СТОЛЬКО ЖЕ
     (замер 31.08 парными тройками: 1.02× от стирания без троттлинга, 1.10×
     при CPU 6×) — выбрано стирание не ради миллисекунд, а потому что ему
     достаётся РОВНО тот путь, которым нарисована сама гора, тогда как clip
     требует своей огибающей, снятой по сетке, то есть границы, лишь
     приближающей силуэт.
     ⚠️ Первый замер этой развилки соврал ЗНАКОМ: неспаренное сравнение
     «браузер А против браузера Б» на общей машине объявило clip вчетверо
     дороже. На этой машине рядом всегда работают чужие сессии, и один и тот
     же вариант там даёт от 1.2 до 7.3 мс на кадр — разброс втрое перекрывает
     измеряемую разницу в четверть. Мерить только чередованием в ОДНОЙ
     странице, парами/тройками подряд, и смотреть долю выигранных пар. */
  function eraseRidge(c, li){
    var L=LAYERS[li], arr=ridges[li], n=arr.length, k;
    c.beginPath(); c.moveTo(0,H);
    for(k=0;k<n;k++){ c.lineTo(k/(n-1)*W, H*L.top - L.amp*H*arr[k]); }
    c.lineTo(W,H); c.closePath();
    c.fill();
  }

  function paintFog(){
    fx.clearRect(0,0,W,H);
    updatePuffs();
    var drawn=false;
    for(var li=1; li<=N-2; li++){
      if(bandLive[li]){ fx.globalCompositeOperation='source-over'; drawBand(li); drawn=true; }
      if(!drawn) continue;                     // стирать нечего — заливку пропускаем
      fx.globalAlpha=1; fx.globalCompositeOperation='destination-out';
      eraseRidge(fx, li+1);
    }
    fx.globalCompositeOperation='source-over'; fx.globalAlpha=1;
  }

  var running=false, raf=0;
  var fogInView=false; // footer visibility (IO-driven) — gates the resize() restart
  /* Декорация уступает работе: пока инструмент считает (tmb:busy true),
     туман стоит. Это общий примитив: любой тул, занимающий CPU надолго,
     шлёт document.dispatchEvent(new CustomEvent('tmb:busy',{detail:{busy}})).
     Без него туман дрался за ядро с DSP пакетной обработки ровно тогда,
     когда человек проматывается к очереди у футера. */
  var workBusy=false;
  document.addEventListener('tmb:busy', function(e){
    workBusy = !!(e.detail && e.detail.busy);
    if(workBusy) stop();
    else if(fogInView && !RM) start();
  });

  /* Бюджет, а не константа: декорация сама меряет цену своего кадра (EMA)
     и разводит кадры так, чтобы съедать НЕ БОЛЬШЕ ~1/9 главного потока на
     любой машине. Дешёвый кадр → ~24 fps; кадр по 16 мс (слабый софтверный
     растр) → сама уходит на ~7 fps; совсем тяжело — почти стоит. Константный
     потолок это не решает: замер 07.08 показал, что под 6× троттлингом
     НЕограниченный rAF сам захлёбывается до 6 fps, и «потолок 24» его бы
     РАЗОГНАЛ. Бюджет — единственная формула, верная и для мощной, и для
     слабой машины. */
  var FRAME_MS=41, lastTs=0, emaCost=0;
  function frame(ts){
    if(!running) return;
    // resize() can bail before buildMountains() (its own C1 fix: broken
    // injected getBoundingClientRect on iOS 12 → early return) — but the
    // IntersectionObserver still start()s the loop, and drawing with empty
    // ridges crashed in yAt (TIMBRICA-FRONTEND-D8). No mountains → park the
    // loop; a later successful resize() restarts it.
    if(!ridges.length){ running=false; return; }
    if(ts && ts-lastTs<FRAME_MS){ raf=requestAnimationFrame(frame); return; }
    lastTs=ts||0;
    var t0=performance.now();
    paintFog();
    var cost=performance.now()-t0;
    emaCost = emaCost ? emaCost*0.9+cost*0.1 : cost;
    FRAME_MS = Math.max(41, emaCost*9);
    raf=requestAnimationFrame(frame);
  }
  function start(){ if(running||workBusy)return; running=true; raf=requestAnimationFrame(frame); }
  function stop(){ running=false; if(raf)cancelAnimationFrame(raf); }

  function staticFrame(){ // one paint without animation (reduced-motion)
    for(var i=0;i<puffs.length;i++) puffs[i].life=puffs[i].max*0.5;
    running=true; frame(); running=false;
  }

  function resize(){
    // Decorative-only: on one iOS 12 device a third-party injection patched
    // Element.getBoundingClientRect ("patchRect" frames) and its broken wrapper
    // threw "Illegal invocation" through us (TIMBRICA-FRONTEND-C1 — same
    // injected environment as the createElement noise). The fog must never
    // throw; skip the repaint when the measurement is unavailable.
    var r;
    try { r=scene.getBoundingClientRect(); } catch(_e){ return; }
    W=Math.max(320,Math.round(r.width*DPR)); H=Math.max(300,Math.round(r.height*DPR));
    fcv.width=W; fcv.height=H; fcv.style.width=r.width+'px'; fcv.style.height=r.height+'px';
    // Горы — тот же бокс, вдвое плотнее по каждой оси (одна и та же система
    // координат: setTransform(SS) в paintStatic, поэтому слои совпадают
    // пиксель-в-пиксель даже когда сработал зажим 320/300).
    cv.width=W*SS; cv.height=H*SS; cv.style.width=r.width+'px'; cv.style.height=r.height+'px';
    buildMountains(); ensurePuffs(); paintStatic(); syncWordmark();
    // Restart a loop that parked itself on empty ridges (see frame()) — but
    // ONLY while the footer is actually on screen. The first version of this
    // restart was unconditional, which UNDID the IntersectionObserver's
    // stop(): any resize() (including the initial one) started a permanent
    // full-canvas rAF animation with the footer far off-screen. On
    // /screen-recorder that background fog loop starved the recording's
    // frame pumps — measured 20 audio frames per 8 s instead of ~360 (the
    // «делал запись 30 минут а только один кадр начала» report #1309 had
    // this as its second root, on top of the composite rAF freeze). When
    // the footer is off-screen the IO's start() covers the restart the
    // moment it scrolls into view.
    if(!running && !RM && fogInView) start();
  }

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // restore the visitor's previously-shuffled silhouette
  try{ var sv=localStorage.getItem('tmb_footer_mtn'); if(sv){ seed=(parseInt(sv,10)||seed)>>>0; } }catch(_){}

  var rT=null;
  function scheduleResize(){ clearTimeout(rT); rT=setTimeout(function(){ resize(); if(RM) staticFrame(); }, 120); }
  window.addEventListener('resize', scheduleResize);
  // footer-fog.css loads async -> the footer is full-height until grid applies.
  // ResizeObserver re-sizes the canvas the moment the real layout settles
  // (and on font load / viewport change), so mountains never get clipped.
  window.addEventListener('load', scheduleResize);
  if('ResizeObserver' in window){ try{ new ResizeObserver(scheduleResize).observe(scene); }catch(_){} }
  resize();

  if(RM){ staticFrame(); }
  else {
    /* Видимость футера — по scroll/resize, а НЕ через IntersectionObserver.
       Замер 2026-08-23 (CDP-трейс, Chromium 143): пока на странице есть хоть
       один живой IntersectionObserver и хоть одна композитная CSS-анимация
       (introGlow шапки тула есть на КАЖДОЙ странице), Blink поднимает главный
       поток на каждый vsync — пересчёт стилей всех анимируемых узлов и
       forced layout под хит-тест, 60 раз в секунду, вечно. Без наблюдателя —
       0 кадров в простое. Один IO этого файла стоил /pocket-pet ~9 мс из
       каждых 16 на троттлинге 4×; троттлинг-проверка здесь дешевле любого
       кадра: один getBoundingClientRect раз в 120 мс, и только при скролле. */
    var vT=null;
    function checkInView(){
      vT=null;
      var r; try{ r=scene.getBoundingClientRect(); }catch(_e){ return; }
      var vh=window.innerHeight||document.documentElement.clientHeight||0;
      var vis = r.bottom>0 && r.top<vh && r.height>0;
      if(vis===fogInView) return;
      fogInView=vis;
      if(vis) start(); else stop();
    }
    function scheduleCheck(){ if(vT) return; vT=setTimeout(checkInView,120); }
    window.addEventListener('scroll', scheduleCheck, {passive:true});
    window.addEventListener('resize', scheduleCheck);
    document.addEventListener('visibilitychange', function(){ if(document.hidden) stop(); else scheduleCheck(); });
    checkInView();
  }

  // user-facing "other mountains" button
  var btn = document.getElementById('footerShuffle');
  if(btn) btn.addEventListener('click', function(){
    seed=(Math.random()*4294967296)>>>0; buildMountains();
    try{ localStorage.setItem('tmb_footer_mtn', String(seed)); }catch(_){}
    paintStatic();
    if(RM) staticFrame();
  });
})();
